"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var validatedViewModel_1 = require("./base/validatedViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
        this.errorMessages.subscribe(function (messages) {
            if (messages && messages.length) {
                alert(messages[0]);
            }
        });
    }
    ViewModel.prototype.beforeSubmit = function (formElement, extendedData, callback) {
        this.errorMessages([]);
        app.f7.modal({
            text: "Вы точно хотите снять иллюстрацию с конкурса?",
            buttons: [{
                    text: "Да",
                    onClick: function () {
                        callback();
                        app.closeModal();
                    }
                },
                {
                    text: "Нет",
                    bold: true
                }]
        });
    };
    ViewModel.prototype.onSubmitSucess = function (result) {
        this.reloadPage();
    };
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=contestMyArts.js.map